import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { CreateOrganisationHierarchyService } from '../create-organisation-hierarchy/create-organisation-hierarchy.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { ViewLevelUsersComponent } from '../view-level-users/view-level-users.component';
import { UsersService } from '../users/users.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SharedService } from 'src/app/shared/shared.service';

@Component({
  selector: 'app-hierarchy-checkboxes',
  templateUrl: './hierarchy-checkboxes.component.html',
  styleUrls: ['./hierarchy-checkboxes.component.scss']
})
export class HierarchyCheckboxesComponent implements OnInit {
	@Input() selectedTemplate: any;
	@Input() globalIndex: any;
	@Input() organisationHierarchy: any;
	@Input() currentHierarchies: any;
	@Input() parentName: any;
	@Input() innerIndex: any;
	@Input() parents: any;
	@Input() localIndex: any;
	@Input() totalHierarchies: any;
	@Input() canEditHierarchy: boolean = false;
	@Input() organisationId: string = '';
	// @Input() orgAllUsers: any;
	@Input() rolesData: any;
	@Input() orgCode: string = '';
	@Input() accordionIndex: any;
	@Output() currentHierarchiesUpdateEvent = new EventEmitter<number>();
	@Output() accordionUpdateEvent = new EventEmitter<number>();
	blockLoader: string = 'blockLoader';
	wrapContent: any = false;
	// users: any;
	managerNames: { [managerId: string]: string } = {};
	isLoadingMgrs = false;

	constructor(
		private snackbar: MatSnackBar,
		private dialog: MatDialog,
		private spinner: NgxSpinnerService,
		private sharedService: SharedService,
		private createOrganisationHierarchyService: CreateOrganisationHierarchyService,
		private usersService: UsersService
	) {}

	ngOnInit(): void {
		// this.usersService.getAllUsersObs(this.organisationId).subscribe((users: any) => {
		// 	this.users = users;
		// 	for (const user of users) {
		// 		this.managerNames[user.id] = user.name;
		// 	}
		// });
	}

	getPlaceholderForHierarchy(hierarchy: any) {
		return `SELECT ${hierarchy.name.toUpperCase()}`;
	}

	hierarchyValueSelection(event: any, hierarchyOption: any, globalIndex: number) {
		if (event.checked) {
			if (!this.organisationHierarchy[globalIndex] || this.organisationHierarchy[globalIndex].length === 0) {
				this.organisationHierarchy[globalIndex] = {
					name: this.selectedTemplate.hierarchies[globalIndex].name,
					values: [{
						levels: [...this.parents],
						value: hierarchyOption
					}]
				};

				this.currentHierarchies += 1;
				this.currentHierarchiesUpdateEvent.emit(this.currentHierarchies);
			} else {
				this.organisationHierarchy[globalIndex].values.push({
					levels: [...this.parents],
					value: hierarchyOption
				});
			}
		} else {
			const indexOfHierarchyValue = this.organisationHierarchy[globalIndex].values.findIndex((val: any) => val.value === hierarchyOption);
			this.organisationHierarchy[globalIndex].values.splice(indexOfHierarchyValue, 1);
			this.clearInnerSelections([...this.parents, hierarchyOption]);


			if (this.organisationHierarchy[globalIndex].values.length === 0) {
				const elementsToSplice = this.organisationHierarchy.length - globalIndex;
				this.organisationHierarchy.splice(globalIndex, elementsToSplice);
				this.currentHierarchies -= elementsToSplice;
				this.currentHierarchiesUpdateEvent.emit(this.currentHierarchies);
			}
		}

		// console.log(this.organisationHierarchy);
	}

	isHierarchyValueSelected(hierarchyOption: any, innerIndex: number, parentCheck: boolean) {
		if (this.organisationHierarchy && this.organisationHierarchy[innerIndex]) {
			return this.organisationHierarchy[innerIndex].values.some((item: any) => {
				if (item.value !== hierarchyOption) {
					return false;
				}

				if (parentCheck) {
					for (let parentLevel of this.parents) {
						if (!item.levels.includes(parentLevel)) {
							return false;
						}
					}
				}

				return true;
			});
		}

		return false;
	}

	getUpdatedParents(parentName: any) {
		return [...this.parents, parentName];
	}

	updateCurrentHierarchies(updatedVal: number) {
		this.currentHierarchies = updatedVal;
		this.currentHierarchiesUpdateEvent.emit(this.currentHierarchies);
	}

	syncHierarchyState(updatedHierarchy: any) {
		this.organisationHierarchy = updatedHierarchy || [];
		if (this.selectedTemplate) {
			this.selectedTemplate.hierarchy = this.organisationHierarchy;
		}
		this.currentHierarchies = this.organisationHierarchy.filter((level: any) => level?.values?.length).length;
		this.currentHierarchiesUpdateEvent.emit(this.currentHierarchies);
	}

	async viewLevelDetails(levelName: string, levelValue: any, localIndex: any) {
		// console.log(this.organisationHierarchy);
		let levels = [];
		for (let i = 0; i < this.parents.length; i += 1) {
			let parent = this.parents[i];

			levels.push({
				name: this.organisationHierarchy[i].name,
				value: parent
			});
		}
		levels.push({
			name: levelName,
			value: levelValue.value
		});
		// console.log(levels);

		await this.spinner.show("blockLoader");
		const filteredUsers: any = await this.createOrganisationHierarchyService.getUsersAtLevel(levels, this.organisationId);
		// console.log(filteredUsers);
		await this.spinner.hide("blockLoader");

		this.dialog.open(ViewLevelUsersComponent, {
			maxWidth: '80%',
			minWidth: '60%',
			data: {
				filteredUsers,
				hierarchyOption: levelValue,
				levelName,
				levels,
				organisationId: this.organisationId,
				organisationHierarchy: this.organisationHierarchy,
				levelIndex: this.innerIndex + 1,
				globalIndex: localIndex,
				// allUsers: this.orgAllUsers,
				rolesData: this.rolesData,
				dynamicGlobal: true,
				orgCode: this.orgCode,
			}
		});
	}

	clearInnerSelections(parents: any) {
		for (let i = 0; i < this.organisationHierarchy.length; i += 1) {
			let orgHierarchy = this.organisationHierarchy[i];

			for (let j = 0; j < orgHierarchy.values.length; j += 1) {
				let orgValue = orgHierarchy.values[j];

				if (orgValue.levels.length >= parents.length && this.matchElementsOrder(parents, orgValue.levels)) {
					orgHierarchy.values.splice(j, 1);
				}
			}
		}
	}

	matchElementsOrder(checkForArray: any, checkInArray: any) {
		for (let i = 0 ; i < checkForArray.length; i += 1) {
			let checkForItem = checkForArray[i];

			if (checkForItem !== checkInArray[i]) {
				return false;
			}
		}
		return true;
	}

	changeInputState(status: string, innerIndex: number, index: number) {
		const divElement = document.getElementById('newLevel-' + innerIndex + 'inner' + index + 'global' + this.globalIndex + 'local' + this.localIndex);
		if (divElement) {
			if (status === 'show') {
				this.wrapContent = true
				divElement.classList.remove('hidden');
				// divElement.classList.add('block-element');
			} else if (status === 'hide') {
				// divElement.classList.remove('block-element');
				divElement.classList.add('hidden');
			}
		}
	}

	getLevelValues(innerIndex: number) {
		if (this.organisationHierarchy[innerIndex] && this.organisationHierarchy[innerIndex].values) {
			const vals = this.organisationHierarchy[innerIndex].values.slice();
			let levelVals = [];

			for (let val of this.organisationHierarchy[innerIndex].values) {
				let doesExist = false;
				for (let i = 0; i < val.levels.length; i += 1) {
					if (val.levels[i] !== this.parents[i]) {
						doesExist = true;
						break;
					}
				}

				if (!doesExist) {
					levelVals.push(val);
				}
			}

			for (let val of levelVals) {
				const pos = this.findPositionInValues(val, vals);
				val.orgIndex = pos;
			}

			levelVals = levelVals.sort((a: any, b: any) => {
				return a.value < b.value ? - 1 : 1;
			});
			return levelVals;
		}

		return [];
	}

	findPositionInValues(val: any, values: any) {
		return values.findIndex((valueObj: any) => {
			return (valueObj.value === val.value && this.sharedService.areArraysEqual(val.levels, valueObj.levels));
		});
	}

	isLevelNameAdded(innerIndex: number, index: number) {
		const inputElement: any = document.getElementById('newLevelName-' + innerIndex + 'inner' + index + 'global' + this.globalIndex + 'local' + this.localIndex);
		if (inputElement) {
			return inputElement.value.length >= 1;
		}
	}

	async addHierarchyLevel(levelSelection: any, innerIndex: number, j: number) {
		const inputElement: any = document.getElementById('newLevelName-' + innerIndex + 'inner' + j + 'global' + this.globalIndex + 'local' + this.localIndex);
		// console.log(inputElement);
		if (inputElement) {
			let valToCompare = String(inputElement.value).toLowerCase().trim();
			const parents = [...this.parents, levelSelection];
			const vals = this.organisationHierarchy[innerIndex + 2]?.values?.length ? this.organisationHierarchy[innerIndex + 2]?.values : [];
			// console.log(vals);
			let levelAlreadyExists = true;
			let msg = "";

			for (let val of vals) {
				// console.log(val);
				for (let i = 0; i < val.levels.length; i += 1) {
					if (val.levels[i] !== parents[i]) {
						levelAlreadyExists = false;
						break;
					}
				}

				if (levelAlreadyExists) {
					if (val.value === valToCompare) {
						msg = "This level already exists!";
						break;
					} else {
						levelAlreadyExists = false;
					}
				}
			}

			// console.log(levelAlreadyExists);
			if (!levelAlreadyExists || vals.length === 0) {
				this.accordionUpdateEvent.emit(this.accordionIndex);
				await this.spinner.show("blockLoader");
				const updatedHierarchy = await this.createOrganisationHierarchyService.addHierarchyValue(
					this.organisationId,
					innerIndex + 2,
					this.selectedTemplate.hierarchies[innerIndex + 2],
					{
						levels: parents,
						value: String(inputElement.value).toLowerCase().trim(),
						displayValue: String(inputElement.value).trim()
					}
				);
				this.syncHierarchyState(updatedHierarchy);
				await this.spinner.hide("blockLoader");
				msg = "Level added successfully!";
				inputElement.value = "";
				this.changeInputState('hide', innerIndex, j);
			}

			this.snackbar.open(msg, "OK", {
				duration: 3000
			});
		}
	}

	getManagerName(managerId: any): string {
		const cachedName = this.managerNames[managerId];
		if (cachedName) {
			return cachedName;
		}
		return '';
	}

	async showManagersList(hierarchyOption: any, enable: any) {
		if (enable) {
			// disable all tooltips so they don't remain visible.
			for (let hierarchyLevel of this.organisationHierarchy) {
				let values = hierarchyLevel.values;

				for (let levelValue of values) {
					levelValue.showManagersList = false;
				}
			}

			for (let hierarchyLevel of this.selectedTemplate.hierarchy) {
				let values = hierarchyLevel.values;

				for (let levelValue of values) {
					levelValue.showManagersList = false;
				}
			}

			if (hierarchyOption.hasLoadedManagers) {
				hierarchyOption.showManagersList = true;
				return;
			} else {
				await this.spinner.show("blockLoader");
				const res: any = await this.usersService.fetchMgrDetails(hierarchyOption.managers);
				await this.spinner.hide("blockLoader");

				hierarchyOption.managerNames = [];
				for (let user of res) {
					hierarchyOption.managerNames.push(user);
				}

				hierarchyOption.showManagersList = true;
				hierarchyOption.hasLoadedManagers = true;
			}
		} else {
			hierarchyOption.showManagersList = false;
		}
	}

	async deleteLevel(globalIndex: number, index: number, value: string) {
		let levels = [...this.organisationHierarchy[globalIndex].values[index].levels, value];
		let levelObjectStr = '';
		for (let i = 0; i < globalIndex; i += 1) {
			if (i === 0) {
				levelObjectStr += `name":"${this.organisationHierarchy[i].name}","value":"${this.organisationHierarchy[globalIndex].values[index].levels[i]}"},`;
			} else {
				levelObjectStr += `{"name":"${this.organisationHierarchy[i].name}","value":"${this.organisationHierarchy[globalIndex].values[index].levels[i]}"},`;
			}
		}
		levelObjectStr += `{"name":"${this.organisationHierarchy[globalIndex].name}","value":"${value}`;
		// console.log(levelObjectStr);
		// let doesUserExist = this.sharedService.doesAnyUserExistAtLevel(levels, this.orgAllUsers);
		await this.spinner.show("blockLoader");
		let doesUserExist = await this.usersService.doesAnyUserExistAtLevel(levelObjectStr, this.organisationId);
		await this.spinner.hide("blockLoader");
		// console.log(doesUserExist);

		if (doesUserExist) {
			this.snackbar.open("You cannot delete this level at this time because users are present", "OK");
		} else {
			this.accordionUpdateEvent.emit(this.accordionIndex);
			await this.spinner.show("blockLoader");
			const updatedHierarchy = await this.createOrganisationHierarchyService.deleteHierarchyBranch(this.organisationId, levels);
			this.syncHierarchyState(updatedHierarchy);
			await this.spinner.hide("blockLoader");
			// this.accordionUpdateEvent.emit(this.accordionIndex);
		}
	}

	deleteLevelsCascade(globalIndex: number, index: number, levels: any) {
		this.organisationHierarchy[globalIndex].values.splice(index, 1);

		for (let i = globalIndex + 1; i < this.organisationHierarchy.length; i += 1) {
			let vals = this.organisationHierarchy[i].values;

			for (let j = 0; j < vals.length; j += 1) {
				let valsJ = vals[j];

				if (this.sharedService.areArraysEqual(levels, valsJ.levels)) {
					this.organisationHierarchy[i].values.splice(j, 1);
				}
			}
		}
	}

	updateActiveAccordion(accordionActiveId: number) {
		this.accordionUpdateEvent.emit(accordionActiveId);
	}
}
